import "./App.css";
import Routes from "./Routes";
import useInitialLoad from "./hooks/useInitialLoad";

function App() {
  const { isLoading } = useInitialLoad();

  return isLoading ? (
    <div className="loader-container" data-testid="app-loader">
      <div className="loader"></div>
    </div>
  ) : (
    // Pre-glassmorphism editorial theme: flat cream/graphite paper, no
    // fixed nature-photo backdrop (see src/components/SiteBackground,
    // now unused — kept in the tree in case a future redesign wants it
    // back, per the restored-theme branch's scope).
    <Routes />
  );
}

export default App;
